import React from "react";
import { Typography, Paper, Grid } from "@mui/material";
import FormTextField from "./FormTextField";
import { ExpertFormState } from "../../Models/expert";
import { useTranslation } from "react-i18next";
import colors from "../../Constants/colors";
import { useWorkspaceColors } from "../../Contexts/WorkspaceColorContext";

interface ValidationErrors {
  expertName?: string;
}

interface ExpertNameProps {
  formState: ExpertFormState;
  handleChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  validationErrors: ValidationErrors;
}

const ExpertName: React.FC<ExpertNameProps> = ({
  formState,
  handleChange,
  validationErrors,
}) => {
  const { t } = useTranslation("expertForm");
  const { colors: workspace } = useWorkspaceColors();
  return (
    <Grid item xs={12}>
      <Paper
        elevation={0}
        sx={{
          p: 3,
          mb: 3,
          borderRadius: 2,
          border: `1px solid ${colors.gray200}`,
          borderLeft: `4px solid ${workspace.primary_dark}`,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            color: workspace.primary_dark,
            fontWeight: 600,
          }}
        >
          {t("expertForm.expertName")}
        </Typography>
        <FormTextField
          label={t("expertForm.expertName")}
          name="expertName"
          value={formState.expertName}
          onChange={handleChange}
          info={t("expertForm.expertNameInfo")}
          minRows={1}
          error={!!validationErrors.expertName}
          helperText={validationErrors.expertName}
        />
      </Paper>
    </Grid>
  );
};

export default ExpertName;
